// Re-export: the implementation moved to `@heraion/shared` (PE-47), because
// `blankSlot` mints slot ids there and `shared` cannot import from `ui`.
// The file stays at this path so the `"./uuid"` subpath export and the two
// jest.mock() calls that name it physically keep resolving.
export { uuidv4 } from "@heraion/shared";
